import { getBuyPageLink } from '@/common/utils/business'

export const app = {
  productivity: [
    {
      name: 'WPS OFFICE',
      icon: '',
      desc: '专业高效的Office工具，全平台覆盖，随时随地办公，支持文字、表格、演示等办公组件不同格式，支持PDF编辑与转换',
      url: 'https://platform.wps.cn/'
    },
    {
      name: '金山PDF',
      icon: '',
      desc: '功能强大的PDF编辑器，轻巧简洁，多格式高效转换，各类内容自由编辑',
      url: 'https://www.wpspdf.cn/'
    },
    {
      name: '轻文档',
      icon: '',
      desc: '新一代在线内容协作工具，容纳丰富的协作矩阵元素，实现更好的数据链转和消息管理',
      url: 'https://www.kdocs.cn/'
    },
    {
      name: '轻表格',
      icon: '',
      desc: '新一代在线表格，数据规范、协作可控、过程可追溯，既能兼容普通表格打通数据，也能基于规范数据搭建轻流程/应用/系统',
      url: 'https://www.kdocs.cn/'
    },
    {
      name: '流程图/脑图',
      icon: '',
      desc: '重组碎片化信息，建立清晰的思维体系'
    },
    {
      name: '金山表单',
      icon: '',
      desc: '便捷的在线信息收集工具，支持手机电脑多端信息同步，随时随地查看收集结果',
      url: 'https://f.wps.cn/'
    }
  ],
  communicate: [
    {
      name: '金山协作',
      icon: '',
      desc: '组织级专属工作平台，即时通讯+文档协作，专注内外部交流协同，全应用顺畅串联',
      url: 'https://xz.wps.cn/'
    },
    {
      name: '金山会议',
      icon: '',
      desc: '适用于学校、教育机构的视频会议解决方案，便捷简单、高性价比，适配多硬件多设备，安全有保障',
      url: 'https://meeting.kdocs.cn/'
    },
    {
      name: '金山邮件',
      icon: '',
      desc: '企业级邮箱解决方案，和文档、联系人深度打通，丝滑的正文编辑和at人体验'
    }
  ],
  management: [
    {
      name: '金山知识管理',
      icon: '',
      desc: '全新一代知识管理系统，帮助企业轻松管理知识，赋能业务发展',
      url: 'https://km.wps.cn/'
    },
    {
      name: '金山云盘',
      icon: '',
      desc: '企业文件统一存储共享、全链路安全保护，支持100+种格式在线预览，云盘文档可在线编辑'
    },
    {
      name: '金山日历',
      icon: '',
      desc: '组织内成员共享日程，一键开启会议群聊，自动关联会议纪要',
      url: 'https://rili.wps.cn/'
    },
    {
      name: '金山待办',
      icon: '',
      desc: '简洁高效的团队任务管理工具，与同事和朋友共享任务分组',
      url: 'https://todo.wps.cn/'
    }
  ],
  ecology: [
    {
      name: '内容生态',
      icon: '',
      desc: '引入高质量合作伙伴内容资源，同时为教育工作者搭建内容分享平台，建设完整内容生态闭环'
    },
    {
      name: '协作中台',
      icon: '',
      desc: '颗粒化IM能力和IM开源，业务快速融合，快速做出自己的IM产品'
    },
    {
      name: '文档中台',
      icon: '',
      desc: '敏捷统一的集成标准，强大且高兼容性的文档服务，丰富灵活可拓展的开放能力'
    },
    {
      name: '应用生态',
      icon: '',
      desc: '应用生态',
      url: 'https://co.wps.cn/workbench/?vcl=v2#/team'
    },
    {
      name: '合作生态',
      icon: '',
      desc: '持续引入高质量合作方，完善开发生态，为企业赋能',
      url: 'https://open.wps.cn/'
    },
    {
      name: '服务生态',
      icon: '',
      desc: '覆盖全国全方位的服务体系，提供整体解决方案能力，提升企业数字办公能力'
    }
  ]
};


export const common = {
  contactSales: 'https://f.kdocs.cn/g/w6W1UqmG/',
  payLink: getBuyPageLink(),
}